<template xmlns:>
<!--   tableDataQueryParams.tableData:{{// tableDataQueryParams.tableData}}-->
<!--    {{tableData}}-->
  <DataTable v-model:selection='selectedItem' :lazy='true'
    :paginator='!pagingShow ? false : (paginator === false ? paginator : true)' :rowHover='true'
    :rows='tableDataQueryParams.bioTechLeaguePagingQuery.rows' :rowsPerPageOptions='[10, 20, 50, 100, 200]'
    :total-records='tableDataQueryParams.totalRecords' :value='tableDataQueryParams.tableData' class='p-datatable-lg'
    :currentPageReportTemplate='pageTips == false ? "" : currentPageReportTemplate' dataKey='id'
    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
    scrollDirection='horizontal' scrollable showGridlines @page='onPage($event)' @sort='onSort($event)' editMode='cell'
    @cell-edit-complete='onCellEditComplete' @update:selection='onSelectionChange' v-model:filters='filters'
    filterDisplay='menu' @filter='onFilter($event)' :loading='loading' table-class='pa' ref='refs'
    :tableStyle='tableStyle' @value-change='onValueChange' :scroll-height='scrollHeight' :export-filename='exportFileName'
    :sort-field='sortField' :sort-order='sortOrder' @rowSelect='onSelect' @row-select-all="onRowSelectAll"
    @row-unselect-all="onRowUnselectAll" @rowUnselect='onUnSelect'>
    <template #empty>
      <div class='notMsg'>
          No data
      </div>
    </template>
    <template #loading>
      <div class='notMsg'>
          Loading
      </div>
    </template>
    <template #header>
      <div style='display:flex;'>
        <div style='flex:7;display:flex;white-space:nowrap;flex-wrap: wrap;'>
          <Button type='button' style='margin:10px'
            icon='pi pi-filter-slash' label='Clear' @click='clearFilters()' />
          <Button type='button' style='margin:10px'
            icon='pi pi-external-link' :label="$t('bioDataTable.export')" @click='exportCSV($event)' />
          <div style='text-align:left' >
            <MultiSelect style='margin:10px;width:200px' :modelValue='selectedColumns' :options='columns'
              optionLabel='header' @update:modelValue='onToggle' placeholder='Select Columns' />
          </div>
          <slot name='headerButton'></slot>
        </div>
        <div style='justify-content: flex-end; display:flex'>
          <div style='min-height:30px;flex:3;margin-top:10px' >
            <span class='p-input-icon-left'>
              <i class='pi pi-search' />
              <InputText v-model="filters['global'].value" :placeholder="$t('bioDataTable.searchInfo')"
                @keydown.enter='search()' style='width: 100%' />
            </span>
          </div>
        </div>
      </div>

    </template>

    <Column :style="selectStyle ? selectStyle : 'width:42px'" v-if='selectColumnShow' :selectionMode='selectMode'>
    </Column>
    <Column header="拖拽" style="width: 6%;" v-if='isDrag'>
      <template #body="slotProps">
        <draggable chosenClass="chosen" :sort="false" style="width: 100%;cursor: move;" :move="draggAdd"
          v-model="tableDataQueryParams.tableData" :group="grpupA" item-key="id">
          <template #item="{ element }">
            <div style="width:100%;text-align: center;" v-if="slotProps.data.id == element.id">
              <!-- <div v-for="items in iconData" :class="items.name == element.sampleType ? items.code : ''"> -->
              <!-- <span v-if="items.name == element.sampleType">
                </span> -->
              <!-- {{ items.name }} /
                {{ element.sampleType }} /
                {{ items.code }}
              </div> -->
              <i style="font-size:20px;color: #5a9cf8;" class="iconfont" v-for="items in iconData"
                :class="items.name == element.sampleType ? items.code : ''"></i>
            </div>
          </template>
        </draggable>
      </template>
    </Column>
    <Column v-for='col of selectedColumns' :data-type='col.dataType' :field='col.field' :header='col.header'
      :header-class='{ "bio_required": col.required }' :filter-field='col.filterField' :key='col.id'
      :sortable='!(col.isSort === false)' :style="'min-height:45px;' + col.style" :frozen="col.frozen" :class="{'bio_datatable_column bio_datatable_column_frozen bio_datatable_column_operate': col.frozen}">
      <template #header v-if='col.isEdit'>
        <i class='pi pi-pencil'></i>
      </template>
      <template #header v-if='col.isRequired'>
        <div style="color:red">*</div>
      </template>
      <template v-if="!(col.isEdit && col.type !== 'dialog')" #body='{ data, field }'>
        <span v-if="col.type=='customCalc'">
            {{col.customCalc?col.customCalc(data):data[field]}}
        </span>
          <span
              v-else-if="col.type === 'btn' && col.click &&!(col?.needEditFunction&&col?.needEditFunction(data))"
              :title='col.filterData ? col.filterData(data[field]) : data[field]'
              style='width: 100%;height:100%;line-height:30px;max-width:700px;display:block;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;display:flex;justify-content:center;'
              @click='col.click(data,field);' >
              <Button icon='pi pi-download' style='margin: 3px;padding: 2px;width: 45px;scale: .8;font-size: 21px;' type='button' />
        </span>
        <!--          <span v-if="!(col.isEdit == true) && field === 'stateName'" :class="'Bio_'+data[field]">{{filterTableData(data,field)}}</span>-->
        <span v-else-if="col.isEdit && col.type === 'dialog' && col.click"
          style='width: 100%;height:100%;padding:10px;display:flex;align-items: center;' @click='col.click(data);'>
          {{ col.filterData ? col.filterData(data[field]) : data[field] }}
        </span>

        <!--    自定义单元格文本的样式  dynamicClass(data, rowData, columnDefine) 函数类型自定义单元格文本的样式  dynamicClass(data, rowData, columnDefine) 函数类型      -->
        <span v-else-if='col.dynamicClass && Object.prototype.toString.call(col.dynamicClass) === "[object Function]"'
          :class='col.dynamicClass(data[field], toRaw(data), toRaw(col))' :data-title='data[field]'>
          {{ col.filterData && Object.prototype.toString.call(col.filterData) === '[object Function]' ?
            col.filterData(data[field]) : data[field]
          }}
        </span>
        <!--    默认单元格文本样式      -->
        <span v-else style='float:left'
          :class="col.filterData ? 'show_line_2 Bio_' + dynamicClass(col.filterData(data[field])) : 'show_line_2'"
          :title='col.filterData && Object.prototype.toString.call(col.filterData) === "[object Function]" ? col.filterData(data[field]) : data[field]'
          v-html='col.filterData ? col.filterData(data[field]) : data[field]'>

        </span>
        <!--        {{ col.filterData ? col.filterData(data[field]) : data[field] }}-->
      </template>
      <template v-show="col.type !== 'dialog'" #body='{ data, field }'>
        <tableContext :col="col" :data="data" :field="field"></tableContext>
      </template>
      <template #editor='{ data, field }' v-if="col.isEdit && col.type !== 'dialog'">
        <div v-if="col?.needEdit && data[col?.needEdit?.needEditField] === col?.needEdit?.needEditValue">
          <tableContext :col="col" :data="data" :field="field"></tableContext>
        </div>
        <div v-else>
          <Dropdown v-if="col.type === 'dropdown' || col.type == 'dicDropdown' || col.type == 'peopleDropdown'"
            @change='dataTableDropDownChange(data.id, col.dropDownProps)' v-model='data[field]' style='width:100%'
            :option-value='col.dropDownProps.optionValue' :option-label='col.dropDownProps.optionLabel'
            :options='col.dropDownProps.options' />
            <InputNumber :min='col.min' v-if="col.type === 'number'" v-model="data[field]" style='width:100%' mode="decimal"
            showButtons :minFractionDigits="col.minFractionDigits?col.minFractionDigits:0"/>
          <InputText v-if="col.type === 'input'" v-model='data[field]' :maxlength="col.maxlength" style='width:100%' />
        </div>
      </template>
      <template #filter='{ filterModel }' v-if="col.isFilter && col.dataType && col.dataType === 'date'">
        <Calendar v-model='filterModel.value' dateFormat='yy-mm-dd' class='p-column-filter' :placeholder='col.header' />
      </template>
      <template #filter='{filterModel}' v-else-if='col.isFilter && col.dataType && col.dataType === "dropdown"'>
        <Dropdown v-model='filterModel.value' :options='col.dropDownProps.options' :placeholder='col.header'
          :option-value='col.dropDownProps.optionValue' :option-label='col.dropDownProps.optionLabel'
          class='p-column-filter' />
      </template>
      <template #filter='{filterModel}' v-else-if='col.isFilter && col.dataType && col.dataType === "conntains"'>
        <InputText type='text' v-model='filterModel.value' class='p-column-filter' :placeholder='col.header' />
      </template>
      <template #filter='{filterModel}' v-else-if='col.isFilter'>
        <InputText type='text' v-model='filterModel.value' class='p-column-filter' :placeholder='col.header' />
      </template>
    </Column>
    <Column v-if='operateColumnShow&&selectedColumns?.length>0'
                :reorderableColumn="false"
                :style="'height:30px;align-items:center;justify-content:center;white-space: nowrap;min-width: 125px;z-index:1;    border: 1px solid #ccc;border-top:none;' + operateColumnStyle"
                align-frozen='right'
                bodyClass='text-center'
                class='bio_datatable_column bio_datatable_column_frozen bio_datatable_column_operate'
                column-key="ajsldaisnkkkjl" frozen headerSty='text-center'>
                <template #body='{ data }'>
                    <template v-if='operateButtons'>
                        <template v-for='(item, index) in operateButtons' :key='index'>
                            <Button v-if='item.buttonStrategy ? item.buttonStrategy(data) : true'
                                    :class="item.className"
                                    :title="item?.title"
                                    :icon='item.icon' :label='item.label' :style='"margin:3px; height:30px;height:30px;" + item.style'
                                    @click='item.click(data)' />
                        </template>
                    </template>
                </template>
      </Column>
  </DataTable>
</template>

<script>
import toLowerLine from '@/utils/toLowerLine';
import { filterTableData } from '@/utils/tableCommon';
import { FilterMatchMode, FilterOperator } from 'primevue/api';
import requests from '@/request';
import request from '@/request';
import { downloadFile, downloadUrlFile } from '@/utils/downloadFile';
import { deleteData as deleteTableData, getTableData } from '@/components/BioDataTable/BioDataTable';
import format from '@/utils/format';
import { toRaw } from 'vue';
import tableSelfAdaption from '../../mixins/tableSelfAdaption';
import tableContext from './tableContext.vue';
import draggable from 'vuedraggable';
import validator from 'validator';

export default {
  name: 'BioDataTable',
  emits: ['add-item', 'selected-item', 'table-data', 'table-data-change', 'choose-item', 'delete-item-after', 'view-item', 'getTableDataInfo'],
  props: ['scrollHeight', 'paginator', 'rows', 'refs', 'selectMode', 'columns', 'url', 'chooseItemUrl', 'buttons', 'jumpPath', 'deleteUrl', 'tableStyle',
    'paramsBody', 'tableData', 'operateColumnStyle', 'fileUploadOptions', 'otherParams', 'operateColumnShow', 'isDto',
    'selectColumnShow', 'uploadFileParams', 'buttonStrategy', 'showColumnParams', 'vieFormPath', 'approvalDetailsPath',
    'viewFilePath', 'downLoadFilePath', 'downLoadFileParams', 'downLoadFileUrl', 'selctedDataOfTable', 'deleteCompleted',
    'buttonDisable', 'exportFileName', 'sortField', 'sortOrder', 'enableRowEdit', 'selectStyle', 'sendReport',
    'checkRequiredFieldUrl', 'needSelfAdption', 'selfAdptionClass', 'operateButtons', 'dataTableCaption', "addItemParams", 'viewLogs', 'istoLowerLine',
    'formName', 'logId', 'logKeyword', 'logIdColumn', 'logRecordColumn', 'isDrag', 'pageTips', 'addDisplay', 'tableMarkers', 'time', 'defaultIconData', 'initMsgNum','isCustomData'
  ],
  mixins: [tableSelfAdaption],
  components: { draggable, tableContext },
  data() {
    return {
      customFieldValue: null,
      customFieldItems: [],
      fixedFieldItems: [],
      grpupA: {
        name: 'site',
        pull: 'clone',
        put: false
      },
      iconData: [],
      notClearIDs: ['/user/systemUserEdit'],
      isdashboard: location.href.includes('dashboard'),
      // 是否分页
      pagingShow: true,
      // 首次row的数量
      initRowsNum: 10,
      dropDownOptions: null,
      dropDownDataTableId: null,
      dropDownChange: false,
      selectedData: null,
      selectedColumns: null,
      currentPageReportTemplate: this.$t('bioDataTable.showing') + ' {first}' + this.$t('bioDataTable.to')
        + ' {last} ' + this.$t('bioDataTable.of') + ' {totalRecords} ' + this.$t('bioDataTable.entries'),
      fileUploadOption: false,
      matchModeFields: [],
      loading: true,
      ids: [],
      selectedItem: null,
      tableDataQueryParams: {
        bioTechLeaguePagingQuery: {
          page: 1,
          rows: 10,
          sort: {},
          pagingSearchOne: {},
          query: [],
        },
        sort: {},
        pagingSearchOne: {},
        query: [],
        tableData: [],
        page: 1,
        rows: 10,
        totalRecords: 0,
      },
      filters: {},
      dataTableChange: false,
      oldDataTable: null,

    };
  },
  watch: {
    'defaultIconData'() {
      this.iconData = this.defaultIconData
    },
    'selectedItem': {
      handler(newVal) {
        // console.log(this.ids)
        //  = this.ids.concat(newVal?.map(el=>el.id))
      },
      deep: true,
      immediate: true,
    },
    'selctedDataOfTable': {
      handler: function (val, oldVal) {
        this.selectedItem = this.selctedDataOfTable instanceof Array ? [] : null;
        if (this.selctedDataOfTable && this.tableDataQueryParams.tableData) {
          this.tableDataQueryParams.tableData.map(item => {
            if (this.selctedDataOfTable instanceof Array) {
              for (let i = 0; i < this.selctedDataOfTable.length; i++) {
                if (item.id == this.selctedDataOfTable[i].id) {
                  this.selectedItem.push(item);
                }
              }
            } else if (item.id == this.selctedDataOfTable.id) {
              this.selectedItem = item;
            }
          });
        }

        if (this.selectMode == 'multiple') {
          this.$emit('selected-item', this.selectedItem && this.selectedItem.length > 0 ? this.selectedItem : null);
          this.$emit('update:selectedItem', this.selectedItem && this.selectedItem.length > 0 ? this.selectedItem : null);
        } else {
          this.$emit('selected-item', this.selectedItem && this.selectedItem.toString() != '{}' ? this.selectedItem : null);
          this.$emit('update:selectedItem', this.selectedItem && this.selectedItem.toString() != '{}' ? this.selectedItem : null);
        }
      },
      deep: true,
      immediate: true,
    },
    'tableData': {
      handler: function (val, oldval) {
        if (val) {
          this.tableDataQueryParams.tableData = this.tableData;
          this.tableDataQueryParams.totalRecords = this.tableData.length;
        }
      },
      immediate: true, deep: true,
    },
    'rows': {
      handler: function (val, oldVal) {
        if (val) {
          this.tableDataQueryParams.bioTechLeaguePagingQuery.rows = val;
        }
      },
      immediate: true, deep: true,
    },
    'paramsBody': {
      handler: function (val, oldVal) {
        if (JSON.stringify(val) !== JSON.stringify(oldVal)) {
          for (let key in val) {
            this.tableDataQueryParams[key] = val[key] || null;
          }
          this.getTableData();
        }
      },
      deep: true,
    },
    'tableDataQueryParams.tableData': {
      handler: function (val, oldVal) {
        // 双向绑定的值
        if (val) {
          this.$emit('table-data-twoBinding', val);
        }
        let temp = JSON.stringify(val);
        let arr = JSON.parse(temp);

        if (val && val.length > 0 && JSON.stringify(val) !== JSON.stringify(oldVal)) {
          let flag = false;
          if (this.selectMode === 'multiple') {
            this.selectedItem = this.selectedItem && this.selectedItem.length ? this.selectedItem : [];
            flag = this.selctedDataOfTable && this.selctedDataOfTable instanceof Array && this.selctedDataOfTable.length;
          }

          if (this.selectMode === 'single') {
            if (!this.selectedItem || !this.selectedItem.length) {
              this.selectedItem = this.selctedDataOfTable;
            }
          }
          if (Array.isArray(arr)) {
            arr = arr.map((copyItem, index) => {
              if (flag) {
                let sIndex = this.selctedDataOfTable.findIndex(selctedDataItem => copyItem.id === selctedDataItem.id);
                if (sIndex > -1) {
                  this.selectedItem.push(this.selctedDataOfTable[sIndex]);
                }
              }

              if (copyItem.id && copyItem.id.indexOf('vue') > -1) {
                copyItem.id = '';
              }

              return copyItem;
            });
          }
          var hasSelectItem = (this.notClearIDs.find((element, index) => location.href.includes(element)))
          var arrs = []
          if (hasSelectItem) {
            if (!_.isEmpty(this.ids)) {
              this.tableDataQueryParams.tableData.forEach(el => {
                if (this.ids.includes(el.id)) {
                  this.selectedItem.push(el)
                  arrs.push(el)
                }
              })
            }
            if (!_.isEmpty(this.ids)) this.selectedItem = arrs
          }
          this.$emit('selected-item', this.selectedItem);
          this.$emit('update:selectedItem', this.selectedItem);
          this.$emit('table-data', arr, this.tableDataQueryParams.totalRecords, !(JSON.stringify(arr) == JSON.stringify(this.oldDataTable)));
        }
        if (val && val.length > 0 && JSON.stringify(val) !== JSON.stringify(this.oldDataTable)) {
          if (Array.isArray(arr)) {
            arr = arr.map((copyItem, index) => {
              if (copyItem.id && copyItem.id.indexOf('vue') > -1) {
                copyItem.id = '';
              }
              return copyItem;
            });
          }
          this.$emit('table-data', arr, this.tableDataQueryParams.totalRecords, true);

        }
        if (val && val.length == 0) {
          this.$emit('table-data', [], 0, !(JSON.stringify(arr) == JSON.stringify(this.oldDataTable)));
        }
        // else {
        //   arr = arr.map((copyItem, index) => {
        //     if (copyItem.id.indexOf('vue') > -1) {
        //       copyItem.id = '';
        //     }
        //     return copyItem;
        //   });
        //   this.$emit('table-data', arr, this.tableDataQueryParams.totalRecords, !(JSON.stringify(arr) == JSON.stringify(this.oldDataTable)));
        // }
      },
      immediate: true,
      deep: true,
    },
    'columns': {
      handler: function (val, oldVal) {
        this.initFitlers(val);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    changeTime(time, pattern) {
      return moment(time).format(pattern)
    },
    onSelect(event) {
      this.$emit('rowSelect', event);
      this.selfAdption();
    },
    onRowSelectAll(event) {
      this.$emit('rowSelectAll', event);
      this.selfAdption();
    },
    onUnSelect(event) {
      this.$emit('rowUnSelect', event);
      this.selfAdption();
    },
    onRowUnselectAll(event) {
      this.$emit('rowUnSelectAll', event);
      this.selfAdption();
    },
    toRaw,
    dataTableDropDownChange(row, dropDownProps) {
      this.dropDownDataTableId = row.id;
      this.dropDownChange = true;
      this.dropDownOptions = dropDownProps;
      // if (dropDownProps.secondOptionParams){
      //   if (!dropDownProps.secondOptionParams.includes("-")){
      //     throw new Error("dropDown的第二个参数必须是以-分割的字符串")
      //   }
      //   let params = dropDownProps.secondOptionParams.split("-")
      //   let field = params[0]
      //   let value = params[1]
      //   row[field] = value
      // }

    },
    dynamicClass(data) {
      switch (data) {
        case '完成':
          return 'complete';
        case '录入完成':
          return 'inputCompleted';
        case '已发运':
          return 'dispatched';
        case '已运输':
          return 'unSubmitted';
        case '成品已接收':
          return 'finishedProductReceived';
        case '新建':
          return 'new';
        case '无效':
          return 'invalid';
        case '取消':
          return 'underReview';
        case '有效':
          return 'valid';
        case '失效':
          return 'loseEfficacy';
        case '审核中':
          return 'underReview';
        case '已作废':
          return 'haveBeenCancelled';
        case '作废':
          return 'haveBeenCancelled';
        case '已退回':
          return 'returned';
        case '样本已接收':
          return 'sampleReceived';
        case '成品收获':
          return 'harvest';
        case '流程中':
          return 'process';
        case '待修改':
          return 'haveBeenCancelled';
        case '开始':
          return 'start';
        case '暂停':
          return 'pause';
      }
    },
    onToggle(value) {
      this.selectedColumns = this.columns.filter(col => value.includes(col));
      this.selfAdption();
    },
    //保存表格显示的列
    saveShowingColumns() {
      let str = '';
      this.selectedColumns.map((item) => {
        str += item.field + ',';
      });
      str = str.substring(str, str.lastIndexOf(','));
      requests({
        url: 'user/addFixedColumns',
        data: {
          module: this.showColumnParams.module,
          tableName: this.showColumnParams.tableName,
          userName: localStorage.getItem('userName'),
          columnName: str,
        },
      });
    },
    // 查询表格显示列
    // getShowColumns() {
    //   this.selectedColumns = this.columns;
    //   if (this.showColumnParams) {
    //     requests({
    //       url: 'user/selectFixedColumns',
    //       data: {
    //         module: this.showColumnParams.module,
    //         tableName: this.showColumnParams.tableName,
    //         userName: localStorage.getItem('userName'),
    //       },
    //     }).then((res) => {
    //       if (res.data.data?.columnName) {
    //         this.selectedColumns = [];
    //         let showColumn = res.data.data.columnName.split(',');
    //         this.columns.map((item, index) => {
    //           showColumn.map((item1, index1) => {
    //             if (item1 == item.field) {
    //               this.selectedColumns.push(item);
    //             }
    //           });
    //         });
    //       }
    //     });
    //   }
    // },
    onValueChange(value) {
      this.$emit('tableDataChange', true);
    },
    bioButtonStrategy(data) {
      if (this.buttonStrategy) {
        return this.buttonStrategy.strategy(data);
      }
    },
    viewFile(data) {
      this.$emit('choose-item', data, 'view');
    },
    downLoadFile(data) {
      console.log(this.paramsBody)
      //判断this.paramsBody中showId是否存在，如果存在则使用showId，否则使用modelContentId
      if (this.paramsBody.showId) {
        downloadFile('file/downloadFile', 'id', data, this.formName, this.paramsBody.showId, this.downLoadFileParams, data.attachmentName);
      }else{
        downloadFile('file/downloadFile', 'id', data, this.formName, this.paramsBody.modelContentId, this.downLoadFileParams, data.attachmentName);
      }
    },
    selectAndDownLoadFile(data) {
      console.log(data)
      if (this.downLoadFileParams) {
        if (!data[this.downLoadFileParams]) {
          this.$toast.add({ severity: 'warn', summary: '未上传附件', life: 3000, });
          return
        }
        downloadFile('file/downloadFile', 'id', data, this.formName, "", this.downLoadFileParams,);
      } else {
        throw new Error("请传入downLoadFileParams参数")
      }
    },
    downloadUrlFile(data) {//根据url地址下载文件
      downloadUrlFile('file/downloadUrlFile', 'id', data);
    },

    sendReports(data) {
      if (data.arc === '1') {
        this.$toast.add({
          severity: 'warn',
          summary: this.$t('ReportSend.projectOrderIds') + ' [' + data.orderNum + ']' + this.$t('ReportSend.hasSendReport'),
          life: 3000,
        });
        return;
      }
      if (data.sendState === '' || data.sendState === null || data.sendState === undefined) {
        this.$toast.add({
          severity: 'warn',
          summary: this.$t('ReportSend.projectOrderIds') + ' [' + data.orderNum + '] ' + this.$t('ReportSend.noSendType'),
          life: 3000,
        });
        return;
      }
      if (data.sendState === '0' && (data.emal === null || data.emal === undefined || data.emal === '')) {
        this.$toast.add({
          severity: 'warn',
          summary: this.$t('ReportSend.projectOrderIds') + '  [' + data.orderNum + ']  ' + this.$t('ReportSend.noEmail'),
          life: 3000,
        });
        return;
      }

      return request({
        url: '/inspectionreport/report/confirm',
        data: {
          sampleReportSends: [data],
        },
      }).then(res => {
        if (res.data.status === 200) {
          this.getTableData();
          this.$toast.add({ severity: 'success', summary: this.$t('ReportSend.sendSuccess'), life: 2000 });
        } else {
          this.$toast.add({ severity: 'error', summary: this.$t('ReportSend.sendFail'), life: 2000 });
        }
      });
    },
    //上传附件
    uploadFile(fill, data) {
      requests({
        url: 'file/uploadFile',
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        params: {
          modelContentId: data.id,
          ownerModel: this.uploadFileParams.ownerModel,
          useType: this.uploadFileParams.useType,
        },
        data: {
          file: fill.files[0],
        },
      }).then(res => {
        if (res.data.status == 200) {
          this.$toast.add({ severity: 'success', summary: 'Success', detail: '上传成功', life: 3000 });
        }
      });
    },
    // 添加明细
    addItem() {
      let tableDataTemp = {
        id: 'vue' + Date.now(),
      };
      // var item ={}
      // if(this.addItemParams){
      //    item = {...this.addItemParams}
      //   item.id = Date.now() + ''
      // }
      // let tableDataTemp =Object.assign({
      //   id:"vue"+Date.now(),
      // },(item))
      this.pagingShow = false
      this.tableDataQueryParams.tableData.unshift(tableDataTemp);
      this.$emit('add-item', tableDataTemp);
      let tempStr = JSON.stringify(this.tableDataQueryParams.tableData);
      let tempObj = JSON.parse(tempStr);
      tempObj.map((item, index) => {
        if (item.id.indexOf('vue') > -1) {
          item.id = '';
        }
      });
      this.$emit('table-data', tempObj, this.tableDataQueryParams.totalRecords, true);
    },
    //考题添加明细
    addItem1() {
      // let tableDataTemp = {
      //   id:"vue"+Date.now()
      // }
      var item = {};
      if (this.addItemParams) {
        item = { ...this.addItemParams };
        item.id = Date.now() + '';
      }
      let tableDataTemp = Object.assign({
        id: 'vue' + Date.now(),
      }, (item));
      this.tableDataQueryParams.tableData.unshift(tableDataTemp);
      this.$emit('add-item', tableDataTemp);
      this.pagingShow = false
      let tempStr = JSON.stringify(this.tableDataQueryParams.tableData);
      let tempObj = JSON.parse(tempStr);
      tempObj.map((item, index) => {
        if (item.id.indexOf('vue') > -1) {
          item.id = '';
        }
      });
      this.$emit('table-data', tempObj, this.tableDataQueryParams.totalRecords, true);
    },
    //过滤表格数据
    filterTableData(data, field) {
      return filterTableData(data, field);
    },
    //导出csv文件
    exportCSV(event) {
      let cloneTableDate = JSON.parse(JSON.stringify(this.tableDataQueryParams.tableData));
      this.tableDataQueryParams.tableData.forEach(el => {
        this.columns.forEach(columnsItem => {
          if (columnsItem.filterData) {
            for (const key in el) {
              if (Object.hasOwnProperty.call(el, key)) {
                const element = el[key];
                if (columnsItem.field == key) {
                  console.log(el, key)
                  el[key] = columnsItem.filterData(element);
                }
              }
            }
          }
          if (el.storageContainerType) {
            if (el.storageContainerType.includes("<svg")) {
              if (el.storageContainerType.includes("液氮罐")) {
                el.storageContainerType = '🫙'
              } else if (el.storageContainerType.includes("冰箱")) {
                el.storageContainerType = '🧊'
              }
            }
          }
        })
      })
      this.tableDataQueryParams.tableData.forEach(el => {
        for (const key in el) {
          if (el[key]) {
            el[key] = '\u00A0' + (el[key])
          }
        }
      })
      console.log(this.tableDataQueryParams.tableData)
      this.$refs.refs.exportCSV();
      this.tableDataQueryParams.tableData = cloneTableDate
      this.selfAdption()

      if (this.formName != undefined && this.formName != null && this.formName != '') {

        //定义一个空数组
        let idStr = [];
        let recordColumnContent = [];
        /**
         * 如果有logRecordColumn字段,则取logRecordColumn字段的值
         * 如果有logRecordColumn字段表示日志要记录
         * 日志记录的内容字段
         */
        if (this.logRecordColumn) {
          cloneTableDate.forEach((item, index) => {
            recordColumnContent.push(item[this.logRecordColumn] || '空')
          })
        }

        /**
         * 如果有logIdColumn字段,则取logIdColumn字段的值
         * 如果有logIdColumn字段表示日志要记录
         * 日志记录的id字段
         */
        if (this.logIdColumn) {
          cloneTableDate.forEach((item, index) => {
            idStr.push(item[this.logIdColumn])
          })
        } else if (this.formName == this.$t('ConfigurationData.configuration')) {
          //循环cloneTableDate,取出其中的id字段存到数组里
          cloneTableDate.forEach((item, index) => {
            idStr.push(item.name)
          })
        } else if (this.formName == this.$t('ProcessExecution.ProcessConfiguration')) {
          //循环cloneTableDate,取出其中的id字段存到数组里
          cloneTableDate.forEach((item, index) => {
            idStr.push(item.flowPathName)
          })
        } else if (this.formName == this.$t('ExportExperimentEdit.exportExperiment') || this.formName == this.$t('experimentCenterAbnormal.experimentCenterAbnormal')) {
          //循环cloneTableDate,取出其中的id字段存到数组里
          cloneTableDate.forEach((item, index) => {
            idStr.push(item.sampleCode)
          })
        } else if (this.formName == this.$t('intermediateProduct.intermediateProduct')) {
          //循环cloneTableDate,取出其中的id字段存到数组里
          cloneTableDate.forEach((item, index) => {
            idStr.push(item.traceCode)
          })
        } else if (this.formName == this.$t('SampleStock.sampleStock')) {
          //循环cloneTableDate,取出其中的id字段存到数组里
          cloneTableDate.forEach((item, index) => {
            idStr.push(item.code)
          })
        } else if(this.formName == this.$t('KnowledgeCenter.knowledgeCenter')){
          //循环cloneTableDate,取出其中的id字段存到数组里
          cloneTableDate.forEach((item, index) => {
            if(item.fileId){
              idStr.push(item.fileId)
            }
          })
        } else {
          //循环cloneTableDate,取出其中的id字段存到数组里
          cloneTableDate.forEach((item, index) => {
            idStr.push(item.id)
          })
        }

        if (!idStr.length) {
          return
        }

        requests({
          url: "/system/UnitDicType/exportCSVLog",
          data: {
            id: this.logId,
            formName: this.formName,
            csvLogKeyword: this.logKeyword || this.$t("Common.ID"),
            idStr: idStr,
            recordColumnContent: recordColumnContent,
          }
        }).then((res) => {
          // this.$refs.refs.exportCSV();
          // this.tableDataQueryParams.tableData = cloneTableDate
        })
      } else {
        // this.$refs.refs.exportCSV();
        // this.tableDataQueryParams.tableData = cloneTableDate
      }
    },

    search() {
      this.tableDataQueryParams.bioTechLeaguePagingQuery.pagingSearchOne['matchMode'] = this.matchModeFields;
      this.tableDataQueryParams.bioTechLeaguePagingQuery.pagingSearchOne['value'] = this.filters.global.value;
      this.getTableData();
    },
    initFitlers(data) {
      if (data) {
        this.matchModeFields = []
        data.map((item, index) => {
          if (item.field) {
            if (this.istoLowerLine) {
              item["filterField"] = item.field
            } else if (item.isCustomField) {
              item["filterField"] = "custom_field_value"
            } else {
              item["filterField"] = toLowerLine(item.field)
            }
            this.matchModeFields.push(item.filterField);
            if (index == 0) {
              this.filters['global'] = { value: null, matchMode: FilterMatchMode.CONTAINS };
            }
            if (item.dataType && item.dataType === 'date') {
              this.filters[item.filterField] = {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
              };
            } else if (item.dataType && item.dataType === 'dropdown') {
              this.filters[item.filterField] = {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
              };
            } else if (item.dataType && item.dataType === 'conntains') {
              this.filters[item.filterField] = {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
              };
            }
            else {
              this.filters[item.filterField] = {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
              };
            }
          }
        });
      }

    },
    clearFilters() {
      this.tableDataQueryParams.bioTechLeaguePagingQuery.pagingSearchOne = {};
      this.tableDataQueryParams.bioTechLeaguePagingQuery.query = [];
      this.initFitlers(this.columns);
      if (this.paramsBody && this.paramsBody.clear) {
        let arr = this.paramsBody.clear;
        for (let i = 0; i < arr.length; i++) {
          for (let key in this.paramsBody) {
            if (key == arr[i]) {
              // eslint-disable-next-line vue/no-mutating-props
              this.paramsBody[key] = null;
            }
          }
        }
      }
      this.ids = [];
      this.getTableData();
    },
    onFilter(event) {
      console.log(event, '111111111这里')
      this.tableDataQueryParams.bioTechLeaguePagingQuery.query = []
      for (let key in event.filters) {
        var filtersArr = [];
        var matchMode = '';
        for (var s in event.filters[key].constraints) {
          var filters = {};
          let content = event.filters[key].constraints[s]['value'];
          var matchModeTemp = event.filters[key].constraints[s]['matchMode'];
          if (content != null) {
            switch (matchModeTemp) {
              case 'startsWith':
                matchMode = 'likeRight';
                break;
              case 'contains':
                matchMode = 'like';
                break;
              case 'notContains':
                matchMode = 'notLike';
                break;
              case 'endsWith':
                matchMode = 'likeLeft';
                break;
              case 'equals':
                matchMode = 'eq';
                break;
              case 'notEquals':
                matchMode = 'ne';
                break;
              case 'dateIs':
                matchMode = 'eq';
                content = format(content, 'YYYY-MM-DD HH:mm:ss') || content;
                break;
              case 'dateIsNot':
                matchMode = 'ne';
                content = format(content, 'YYYY-MM-DD HH:mm:ss') || content;
                break;
              case 'dateBefore':
                matchMode = 'lt';
                content = format(content, 'YYYY-MM-DD HH:mm:ss') || content;
                break;
              case 'dateAfter':
                matchMode = 'gt';
                content = format(content, 'YYYY-MM-DD HH:mm:ss') || content;
                break;
            }
            filters['operator'] = event.filters[key].operator;
            filters['value'] = content;
            filters['fieldName'] = key;
            filters['matchMode'] = matchMode;
          }
          filtersArr.push(filters);
        }
        if (filtersArr.length > 0 && JSON.stringify(filters) !== "{}") {
          // filtersArr[0].value = '1'
          // var needChange = this.getBeforeValue(filtersArr[0])
          // if(needChange){
          //    filtersArr[0].value = this.getBeforeValue(filtersArr[0])
          // }
          this.tableDataQueryParams.bioTechLeaguePagingQuery.query.push(filtersArr)
        }
      }
      console.log(event, '111111111这里2')

      this.getTableData();
    },
    getBeforeValue(val) {
      var beforeFun = this.columns.find(el => el.field == val.fieldName)
      if (!beforeFun || beforeFun.filterData == undefined) return false
      if (beforeFun.filterData.toString() == 'function () { [native code] }') {
        // console.error("把状态值放在自定义方法里面",beforeFun.filterData)
        return false
      }
      // console.log(this.columns,'this.columns')
      console.log(val.value, 'val')
      // console.log(beforeFun.filterData.toString(),'toString')
      console.log(this.getFunArr(beforeFun.filterData.toString()), '生成了')
      // switch判断的值是否生成为key,val的数组
      if (this.getFunArr(beforeFun.filterData.toString()) === false) return false
      var switchArr = this.getFunArr(beforeFun.filterData.toString())
      var result = ''
      switchArr.forEach(el => {
        console.log(this.$t(el.val), val.value)
        if (this.$t(el.val) == val.value) {
          result = el.key
        }
      });
      // console.log(switchArr,'switchArr',result)
      return result || false

    },
    getFunArr(str) {
      var isSwitch = str.includes('function') && str.includes('switch') && str.includes('case')
      if (isSwitch) {
        var key = /case ["'](.*?)["']/g
        var value = /t\(["'](.*?)["']\)/g
        var newKeys = str.match(key)
        var newValues = str.match(value)
        var resultKeys = newKeys.map((item, index) => {
          return item.replace('case', '').replace(/["']/g, '').trim()
        })
        console.log(str, newValues, 'newValues')
        var resultValues = newValues?.map((item, index) => {
          return item.replace('t(', '').replace(')', '').replace(/["']/g, '').trim()
        })
        // console.log(resultKeys,resultValues)
        var arr = []
        for (let index = 0; index < resultKeys.length; index++) {
          const element = resultKeys[index];
          const element2 = resultValues[index];
          arr.push({ key: element, val: element2 })
        }
        return arr

      } else {
        // console.error('不是switch语句判断')
        return false
      }

    },
    deleteData(event, data) {
      this.$confirm.require({
        message: this.$t('CommonTip.deleteConfirm'),
        header: this.$t('CommonTip.choose'),
        icon: 'pi pi-exclamation-triangle',
        accept: async () => {
          // 所有待删除的id
          let allDeleteIds = data && typeof data === 'string' ? [data] : (this.ids);
          // 所有待删除的id中的vueId，即添加明细增加的数据，尚未保存至后端
          let vuePosIds = allDeleteIds.filter(item => item.indexOf('vue') > -1);
          // 所有待删除的id中的非vueId，即已保存至后端的数据
          let notVuePosIds = allDeleteIds.filter(item => item.indexOf('vue') === -1);

          // 是否删除成功
          let deleteSuccess = true;

          // 后端删除
          let deleteResponseData = null;
          if (notVuePosIds.length) {
            deleteResponseData = await deleteTableData({ ids: notVuePosIds, ...this.paramsBody }, this.deleteUrl);
            deleteSuccess = (deleteResponseData.data.status === 200);
          }

          if (!deleteSuccess) {
            // 后端删除失败
            this.$emit('delete-item-after', { event: event, type: 'delete-item-after', success: false, result: null });
            this.$toast.add({ severity: 'error', summary: this.$t('CommonTip.deleteFail'), life: 2000 });
            return;
          }

          // 更新表格数据
          this.tableDataQueryParams.tableData = this.tableDataQueryParams.tableData.filter(item => {
            const isExisted = allDeleteIds.includes(item.id);
            if (isExisted) {
              this.tableDataQueryParams.totalRecords--;
            }
            return !isExisted;
          });

          // 更新表格已选中数据
          this.ids = [];
          if (this.selectedItem && this.selectedItem.length) {
            this.selectedItem = this.selectedItem.filter(item => {
              const isExisted = allDeleteIds.includes(item.id);
              if (!isExisted) {
                this.ids.push(item.id);
              }
              return !isExisted;
            });
          }

          // 当表格数据为空时，刷新表格
          if (this.tableDataQueryParams.tableData.length === 0) {
            await this.getTableData();
          }

          if (Reflect.has(this, 'deleteCompleted') && typeof this.deleteCompleted === 'function') {
            this.deleteCompleted(data, this.tableDataQueryParams.tableData);
          }

          this.$emit('selected-item', this.selectedItem);
          this.$emit('update:selectedItem', this.selectedItem);
          this.$emit('delete-item-after', {
            event: event,
            type: 'delete-item-after',
            success: deleteSuccess,
            result: deleteResponseData,
            data: data
          });
          this.$toast.add({ severity: 'success', summary: this.$t('CommonTip.deleteSuccess'), life: 2000 });
        },
        reject: () => {

        },
      });


    },
    view(data) {
      if (this.viewLogs) {
        //审计追踪查看方法，调用上级页面方法
        this.$emit('view-item', data);
        return;
      }
      if (this.jumpPath && this.jumpPath.url) {
        let query = this.jumpPath.fixedParams || {};
        if (this.jumpPath.fieldName && this.jumpPath.fieldName.length > 0) {
          this.jumpPath.fieldName.map((item, index) => {
            let temp1 = item.split('-')[0] || item;
            let temp2 = item.split('-')[1] || item;
            query[temp2] = data[temp1];
          });
        } else {
          query['id'] = data.id;
        }
        this.$router.push({ path: this.jumpPath.url, query: { ...query, type: 'view' } });
      } else {
        throw new Error('请配置跳转路径');
      }
    },
    edit(data) {
      if (this.jumpPath && this.jumpPath.url) {
        let query = this.jumpPath.fixedParams || {};
        if (this.jumpPath.fieldName && this.jumpPath.fieldName.length > 0) {
          this.jumpPath.fieldName.map((item, index) => {
            let temp1 = item.split('-')[0] || item;
            let temp2 = item.split('-')[1] || item;
            query[temp2] = data[temp1];
          });
        } else {
          query['id'] = data.id;
        }
        this.$router.push({ path: this.jumpPath.url, query: { ...query, type: 'edit' } });
      } else {
        throw new Error('请配置跳转路径');
      }
    },
    add() {
      this.$router.push({ path: this.jumpPath.url, query: { id: '', type: 'add' } });
    },
    chooseItem(data) {
      this.$emit('choose-item', data);
    },
    onCellEditComplete(event) {
      let { data, newData, newValue, field, value, originalEvent } = event;
      let column = this.columns.filter(item => item.field === field)[0];
      let msg = null
      if (column) {
        if (column.type === 'calendar') {
          data[field] = format(newValue, column.pattern || 'YYYY-MM-DD HH:mm:ss');
        } else {
          data[field] = newValue;
        }
        if (column.rule) {
          switch (column.rule) {
            case "phoneRule":
              if (validator.isMobilePhone(newValue || '')) {
                data[field] = newValue
              } else {
                data[field] = ""
                msg = '手机号码格式不正确'
              }
              break;
            case "emilRule":
              if (validator.isEmail(newValue || '')) {
                data[field] = newValue
              } else {
                data[field] = ""
                msg = '邮箱格式不正确'
              }
              break;
            case "idCardRule":
              // 身份证号的正则表达式
              var regex = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/;
              // 使用正则表达式进行匹配
              if (regex.test(newValue || '')) {
                data[field] = newValue
              } else {
                data[field] = ""
                msg = '身份证号码格式不正确'
              }
              break
          }
        }
        if (msg) {
          this.$toast.add({ severity: 'warn', summary: msg, life: 2000 })
        }
        if (column.onCellEditCompletedCallback) {
          column.onCellEditCompletedCallback({
            originalEvent,
            data,
            newValue,
            newData,
            tableData: this.tableDataQueryParams.tableData,
            oldValue: value,
          });
        }
        if (this.dropDownChange) {
          if (this.dropDownOptions.secondOptionParams) {

            if (!this.dropDownOptions.secondOptionParams.includes('-')) {
              throw new Error('dropDown的第二个参数必须是以-分割的字符串');
            }

            let tempStr = JSON.stringify(this.dropDownOptions);
            let temp = JSON.parse(tempStr);
            let optionValue = temp.optionValue;
            let params = this.dropDownOptions.secondOptionParams.split('-');
            let fields = params[0];
            let value = params[1];
            for (let item = 0; item < temp.options.length; item++) {
              if (temp.options[item][optionValue] == data[field]) {
                data[fields] = temp.options[item][value];
              }
            }
          }
          this.dropDownOptions = null;
          this.dropDownDataTableId = null;
          this.dropDownChange = false;
        }
      } else {

        event.preventDefault();
      }
      // 数据变化监测
      // if (JSON.stringify(this.tableDataQueryParams.tableData) != JSON.stringify(this.oldDataTable)) {
      // 处理自定义字段
      this.tableDataQueryParams.tableData.forEach((item, index) => {
        let arr = []
        for (let i = 0; i < this.customFieldItems.length; i++) {
          console.log(this.customFieldItems[i])
          let obj = {}
          if (item[this.customFieldItems[i].columnName]) {
            obj[this.customFieldItems[i].columnName] = item[this.customFieldItems[i].columnName]
          } else {
            obj[this.customFieldItems[i].columnName] = ''
          }
          arr.push(obj)
          item.customFieldValue = JSON.stringify(arr)
        }
      });

      this.$emit('table-data', this.tableDataQueryParams.tableData);
      // }
    },
    onSelectionChange(event) {
      var hasSelectItem = (this.notClearIDs.find((element, index) => location.href.includes(element)))
      if (!hasSelectItem) this.ids = [];
      if (event.length > 0) {
        event.map(item => {
          if (!this.ids.length || this.ids.indexOf(item.id) === -1) {
            this.ids.push(item.id);
          }
        })
      } else {
        this.ids = [];
      }
      this.$emit('selected-item', event ? event : []);
      this.$emit('update:selectedItem', event ? event : []);
    },
    getTableData() {
      if(this.isCustomData)return
      if (this.paramsBody) {
        for (let key in this.paramsBody) {
          this.tableDataQueryParams[key] = this.paramsBody[key];
        }
      }
      let temp = null;
      if (this.isDto) {
        let tempStr = JSON.stringify(this.tableDataQueryParams);
        temp = JSON.parse(tempStr);
        temp.tableData = [];
      } else {
        temp = this.tableDataQueryParams.bioTechLeaguePagingQuery;
      }
      let tablePromise = getTableData(temp, this.url);
      // this.selfAdption();
      this.tableDataQueryParams.tableData = []
      tablePromise.then(res => {
        this.pagingShow = true
        this.selectedItem = null;
        this.$emit('selected-item', this.selectedItem);
        this.$emit('update:selectedItem', this.selectedItem);
        this.$emit('getTableDataInfo', res);
        this.loading = false;
        // this.selfAdption();
        this.tableDataQueryParams.tableData = []
        if (res.status == 200) {
          for (let index = 0; index < this.notClearIDs.length; index++) {
            var element = this.notClearIDs[index];
            if (!location.href.includes(element)) this.ids = [];
          }

          if ((res.data.data?.result?.length || 0) >= (this.initMsgNum || 50)) {
            this.sliceRendering(res.data.data.result)
          } else {
            this.tableDataQueryParams.tableData = res?.data?.data?.result || [];
          }
          this.asynsInitFun()

          this.tableDataQueryParams.totalRecords = res?.data?.data?.total || 0;
          let str = JSON.stringify(this.tableDataQueryParams.tableData);
          this.oldDataTable = JSON.parse(str);
          //   处理自定义字段
          if (this.tableMarkers) {
            this.tableDataQueryParams.tableData.map((item, index) => {
              if (item.customFieldValue) {
                let arr = JSON.parse(item.customFieldValue);
                arr.map((item1, index1) => {
                  for (let key in item1) {
                    item[key] = item1[key];
                  }
                });
              }
            });
          }
          this.$emit('table-data-two-binding', this.tableDataQueryParams.tableData);
        } else {
          this.tableDataQueryParams.totalRecords = 0
          throw new Error('获取表格数据失败');
        }
        this.selectedItem = null;
      });
      return tablePromise;
    },
    sliceRendering(data) {
      this.tableDataQueryParams.tableData = []
      let container = this.tableDataQueryParams.tableData
      let total = data.length;
      let once = 50;
      let page = Math.ceil(total / once)
      let index = 0;
      console.log(index, 'index', page, 'page', container.length)
      var that = this;
      function loop(curTotal, curIndex) {
        if (index >= page) {
          return false;
        }
        // console.log(index, page,'====>>')
        that.initTableTd()
        that.$parent.changeInputCount = -1
        window.requestAnimationFrame(function () {
          setTimeout(() => {
            // console.log(data.slice(index*once,(index+1)*once),'data.slice(index*once,(index+1)*once)')
            if (!JSON.stringify(that.tableDataQueryParams.tableData).includes(JSON.stringify(data.slice(index * once, (index + 1) * once)))) {
              that.tableDataQueryParams.tableData.push(...data.slice(index * once, (index + 1) * once))
              // console.log(index,'+index')
            }
            that.$parent.changeInputCount = -1
            index++
            loop()
          }, 200);
        })
        // console.log(index,page,'indexindex',index*once,(index+1)*once)
      }
      loop(total, index);
    },
    onPage(event) {
      this.tableDataQueryParams.bioTechLeaguePagingQuery.page = event.page + 1;
      this.tableDataQueryParams.bioTechLeaguePagingQuery.rows = event.rows;
      this.getTableData();
      // this.tableDataQueryParams = onPagesForBioDdataTable(event,this.tableDataQueryParams,getTableData,this.url)
    },
    onSort(event) {
      if (this.istoLowerLine) {
        this.tableDataQueryParams.bioTechLeaguePagingQuery.sort['sortFiled'] = event['sortField'];
      }else{
        this.tableDataQueryParams.bioTechLeaguePagingQuery.sort['sortFiled'] = toLowerLine(event['sortField']);
      }
      this.tableDataQueryParams.bioTechLeaguePagingQuery.sort['sortOrder'] = event['sortOrder'];
      this.getTableData();

    },
    approvalDetails(data) {
      if (this.approvalDetailsPath && this.approvalDetailsPath.url) {
        let query = this.jumpPath.fixedParams || {};
        if (this.jumpPath.fieldName && this.jumpPath.fieldName.length > 0) {
          this.jumpPath.fieldName.map((item, index) => {
            let temp1 = item.split('-')[0] || item;
            let temp2 = item.split('-')[1] || item;
            query[temp2] = data[temp1];
          });
        } else {
          query['id'] = data.id;
        }
        this.$router.push({ path: this.jumpPath.url, query: { ...query, type: 'view' } });
      } else {
        throw new Error('请配置跳转路径');
      }
    },
    vieForm(data) {
      if (this.vieFormPath && this.vieFormPath.url) {
        let query = this.jumpPath.fixedParams || {};
        if (this.jumpPath.fieldName && this.jumpPath.fieldName.length > 0) {
          this.jumpPath.fieldName.map((item, index) => {
            let temp1 = item.split('-')[0] || item;
            let temp2 = item.split('-')[1] || item;
            query[temp2] = data[temp1];
          });
        } else {
          query['id'] = data.id;
        }
        this.$router.push({ path: this.jumpPath.url, query: { ...query, type: 'view' } });
      } else {
        throw new Error('请配置跳转路径');
      }
    },
    /**
     * 校验当前页必填项
     * 纯前端校验
     * @returns {{totalRecords: number, success: boolean, column: null, defaultMessage: string, page: number}}
     */
    checkRequiredFieldsOfCurrentPage() {
      // 校验结果
      let result = {
        success: true,
        defaultMessage: '',
        column: null,
        page: this.tableDataQueryParams.bioTechLeaguePagingQuery.page,
        totalRecords: this.tableDataQueryParams.totalRecords,
        result: null,
      };

      if (this.columns && this.columns.length) {
        // 获取必填项的字段列
        const requiredColumns = this.columns.filter(item => item.required);
        const tableData = this.tableDataQueryParams.tableData;
        // 前端数据校验
        if (requiredColumns.length && tableData && tableData) {
          for (let i = 0; i < tableData.length; i++) {
            const item = tableData[i];
            for (let j = 0; j < requiredColumns.length; j++) {
              const column = requiredColumns[j];
              if (!Reflect.has(item, column.field)
                || item[column.field] === undefined
                || item[column.field] === null
                || item[column.field] === ''
              ) {

                result.success = false;
                result.defaultMessage = (this.dataTableCaption ? '【' + this.dataTableCaption + '】表格' : '') + `必填项【${column.header}】未填写`;
                result.column = column;

                // 提示必填项未填写
                if (!result.success) {
                  this.$toast.add({ severity: 'warn', summary: result.defaultMessage, life: 2000 });
                }

                return result;
              }
            }
          }
        }
      }

      return result;
    },
    /**
     * 校验所有页必填项
     * 纯后端校验
     * @returns {Promise<{totalRecords: number, success: boolean, column: null, defaultMessage: string, page: number}>}
     */
    async checkRequiredFieldsOfAllPage() {
      // 校验结果
      let result = {
        success: true,
        defaultMessage: '',
        column: null,
        page: this.tableDataQueryParams.bioTechLeaguePagingQuery.page,
        totalRecords: this.tableDataQueryParams.totalRecords,
        result: null,
      };
      if (this.columns && this.columns.length) {
        // 获取必填项的字段列
        const requiredColumns = this.columns.filter(item => item.required && !item.isCustomField);

        // 后端数据校验
        if (result.success && requiredColumns.length && this.url) {
          let pagingSearchOne = {
            matchMode: requiredColumns.map(item => toLowerLine(item.field)),
            value: '',
          };

          let bioTechLeaguePagingQuery = {
            page: 1,
            // rows: this.tableDataQueryParams.totalRecords,
            rows: 1,
            checkRequired: '1',
            sort: {
              sortFiled: '',
              sortOrder: '',
            },
            query: [],
            pagingSearchOne,
          };

          let params = this.isDto ? {
            bioTechLeaguePagingQuery,
            ...this.paramsBody,
          } : bioTechLeaguePagingQuery;

          let checkRequiredFieldResponse = await request({
            url: this.url,
            method: 'post',
            data: params,
          });

          if (checkRequiredFieldResponse?.data?.status === 200 && checkRequiredFieldResponse.data?.data) {
            result.result = checkRequiredFieldResponse.data.data;
            result.success = checkRequiredFieldResponse.data.data.total === 0;
            // result.defaultMessage = this.$t('Common.Validate.RequiredNotFilled');
            if (!result.success) {

              /**
               * 找到第一个未填写的必填项
               * 由于MySQL数据库中select '' = 0 返回为true
               * 也会有可能出现必填项填写了返回的情况
               * notFilledColumns长度为0时，也说明必填项全部填写了
               */
              let first = result.result.result[0];
              const notFilledColumns = requiredColumns.filter(column => first[column.field] === undefined || first[column.field] === null || first[column.field] === '');
              result.success = notFilledColumns.length === 0;

              if (!result.success) {
                result.column = notFilledColumns[0];
                result.defaultMessage = (this.dataTableCaption ? '【' + this.dataTableCaption + '】表格' : '') + `必填项【${result.column.header}】未填写`;
              }

            }

          } else {
            // 提示请求异常
            this.$toast.add({ severity: 'error', summary: '请求异常', life: 2000 });
            throw new Error('请求异常');
          }
        }
      }

      // 提示必填项未填写
      if (!result.success) {
        this.$toast.add({ severity: 'warn', summary: result.defaultMessage, life: 2000 });
      }

      console.log('表格必填项校验checkRequiredFieldsOfAllPage', result);

      return result;
    },
    //   查询自定义字段
    async getCustomFields() {
      if (this.tableMarkers)
        await requests({
          url: '/system/custom/findModuleFieldByModuleId',
          data: {
            flag: this.tableMarkers,
            time: this.time
          },
        }).then(res => {
          if (res?.data?.data?.length) {
            let data = res.data.data;
            for (let i = 0; i < data.length; i++) {
              if (data[i].flag == this.tableMarkers) {
                // 自定义字段
                if (!this.customFieldValue) {
                  this.customFieldItems = data[i].customFieldDefaultItems || []
                }
                if (this.customFieldValue) {
                  // 隐藏的固定字段
                  let temp = data[i].customFieldFixedItems || [];
                  temp.forEach(item => {
                    this.fixedFieldItems.push(item.columnName);
                  });
                } else {
                  this.fixedFieldItems = [];
                }
              }
            }
          }
        })
    },
    //   查询字典
    getDicOptions(id) {
      requests({
        url: 'system/PersonnelGroup/selectOnePersonnelGroup',
        data: {
          bioTechLeaguePagingQuery: {
            page: 1,
            rows: 1000,
          },
          id: id,
        },
      }).then(res => {
        if (res?.data?.data) {
          return res.data?.data?.result;
        }
      });

    }


  },
  computed: {},

  async created() {
    await this.getCustomFields();
    for (let i = 0; i < this.customFieldItems.length; i++) {
      // eslint-disable-next-line vue/no-mutating-props
      if (this.customFieldItems[i].state == 1) {

        let obj = {
          field: this.customFieldItems[i].columnName,
          header: this.customFieldItems[i].displayName,
          required: this.customFieldItems[i].required == 1 ? "true" : false,
          style: "width:200px",
          isFilter: true,
          isEdit: true,
          type: this.customFieldItems[i].fieldType,
          dropDownProps: {},
          showSecond: true,
          isCustomField: true,
          rule: this.customFieldItems[i].regularChecke,
        }
        if (this.customFieldItems[i].fieldType == 'calendar') {
          obj.pattern = "YYYY-MM-DD HH:mm:ss"
        }
        if (this.customFieldItems[i].fieldType == 'dropdown' && this.customFieldItems[i].options) {
          let options = []
          let arr = JSON.parse(this.customFieldItems[i].options)
          for (let j = 0; j < arr.length; j++) {
            options.push({ id: arr[j], name: arr[j] })
          }
          obj.dropDownProps = {
            optionValue: 'id',
            optionLabel: 'name',
            options: options,
          }
        }
        // 处理字典下拉框
        if (this.customFieldItems[i].fieldType == 'dicDropdown') {
          await requests({
            url: '/system/DicType/selectUserDicTypeOne',
            params: {
              type: this.customFieldItems[i].dictType,
            },
          }).then(res => {
            if (res?.data?.data) {
              let options = []
              let arr = res.data?.data
              obj.dropDownProps = {
                optionValue: 'name',
                optionLabel: 'name',
                options: arr,
              }
            }
          });
        }

        // 处理人员下拉框
        if (this.customFieldItems[i].fieldType == 'peopleDropdown') {
          await requests({
            url: 'system/PersonnelGroup/selectOnePersonnelGroup',
            data: {
              bioTechLeaguePagingQuery: {
                page: 1,
                rows: 1000,
              },
              id: this.customFieldItems[i].personGroupFlag,
            },
          }).then(res => {
            if (res?.data?.data) {
              let options = []
              let arr = res.data?.data?.result
              obj.dropDownProps = {
                optionValue: 'username',
                optionLabel: 'name',
                options: arr,
              }
            }
          });
        }
        this.columns.push(obj)
      }
    }
    this.columns.some((item, index) => {
      if (this.fixedFieldItems.indexOf(item.field) > -1) {
        this.columns.splice(index, 1);
      }
    })
    this.selectedColumns = this.columns;


    // this.getShowColumns();
    if (this.sortField && this.sortOrder) {
      this.tableDataQueryParams.bioTechLeaguePagingQuery.sort.sortFiled = this.sortField;
      this.tableDataQueryParams.bioTechLeaguePagingQuery.sort.sortOrder = this.sortOrder;
      this.tableDataQueryParams.sort.sortFiled = this.sortField;
      this.tableDataQueryParams.sort.sortOrder = this.sortOrder;
    }
    if (this.paramsBody) {
      for (let key in this.paramsBody) {
        this.tableDataQueryParams[key] = this.paramsBody[key] || '';
      }
      this.getTableData();
    } else {
      if (this.tableData || this.url == null || this.url == undefined) {
        this.loading = false;
      } else {
        this.getTableData();
      }
    }

  },
  mounted() {
    this.initRowsNum = this.rows
    this.newSelfAdption();
  },


};
</script>


<style lang='scss' scoped>
::v-deep .viewed {
    background-color: mediumseagreen !important; /* 提高优先级 */
}
.bio_datatable_column {
}

.bio_datatable_column_frozen {
}

.bio_datatable_column_operate {
}

/**
解决表格行hover时，背景阴影色只生效一半的问题
 */
// :deep(.p-datatable-thead){
//   tr {
//     th{
//       width: auto !important;
//       flex:1 !important;
//     }
//   }
// }
:deep(.p-datatable-tbody) {

    // tr td{
    //     flex:1
    //   }
    //   tr td.p-selection-column{
    //     flex:none !important
    //   }
    tr:not(.p-highlight):hover {
        color: #212529;
        background-color: transparent !important;

        td:not(.bio_datatable_column_operate) {
            color: #212529;
            background-color: rgba(68, 72, 109, 0.07);
        }

    }

    tr.p-highlight {
        color: #44486D;
        background-color: transparent !important;

        td:not(.bio_datatable_column_operate) {
            color: #44486D;
            background: linear-gradient(0deg, rgba(15, 139, 253, 0.1), rgba(15, 139, 253, 0.1)), #FFFFFF;
        }
    }
}

// :deep(tr.p-datatable-emptymessage) {
//   td {
//     width: 100%;
//     justify-content: center;
//   }
// }

:deep(.p-column-title) {
    white-space: nowrap;
}

:deep(.p-button .pi) {
    font-size: .7rem;
    line-height: 0;
}

:deep(.bio_datatable_column) {
    .p-button-icon-only {
        width: 24px;
        height: 24px;
    }
}

:deep(.p-button-label) {
    overflow-wrap: break-word;
    word-wrap: break-word;
    white-space: nowrap;
}

:deep(.p-datatable-table) {
    // table-layout: fixed !important;
    table-layout: auto !important;
}

.notMsg {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px;
}

.wrap {
    overflow-wrap: break-word;
    word-wrap: break-word;
    white-space: nowrap;
}

:deep(.setClassTd .p-inputtext) {
    padding: .3rem 0.571rem !important;
    width:100%;
}

:deep(.p-datatable-header) {
    padding: 0 !important;
}

:deep(.p-datatable-wrapper) {
    border: 0 solid #ccc;
    border-top-width: 1px;
}

:deep(.p-column-header-content) {
    display: flex;
    justify-content: center;
    align-items: center;
}

:deep(.setClassTh) {
    z-index:61 !important;
    .p-frozen-column {
        right: 0 !important;
    }

    th {
        display: table-cell !important;
        background: #ECECF9 !important;
        border: 1px solid #ccc;
        // border-width: 1px 1px 1px 1px;
        border-top: none;
        min-height: 80px;
        padding: 5px 10px;
        color: #8A8EA6;
        font-weight: 500;
        //width: 200px;
        border-radius: 0;
    }

    .bio_required {
        .p-column-title {
            position: relative;
        }

        .p-column-title::before {
            content: "*";
            color: red;
            position: absolute;
            right: -6px;
            top: -4px
        }
    }

    .bio_required:before {
        content: "";
        color: red;
        position: absolute;
        right: 6px;
    }
}

:deep(.setClassTd) {
    .p-frozen-column {
        right: 0 !important;
        text-align:center;
    }

    tr {
        td {
            border: 1px solid #ccc;
            padding: 0 10px;
            color: #44486D;
            //height: 46px;
            max-width: 210px;
            overflow: hidden;
        }
    }

    tr:not(.p-highlight):hover {
        background: linear-gradient(0deg, #F0F1F4, #F0F1F4), #FFFFFF;

    }

    & > .p-highlight {
        background: linear-gradient(0deg, rgba(15, 139, 253, 0.1), rgba(15, 139, 253, 0.1)), #FFFFFF;
    }

    .p-column-title {
        display: none;
    }

    .bio_datatable_column {
        background: #ECECF9;
        border: 1px solid #ccc;
        //width: 125px !important;
    }
}

:deep(.p-datatable-wrapper) {
    clear: both;
}

:deep(.headerBtns > div) {
    float: left !important;
}

:deep(.headerBtns) {
    button {
        float: left;
    }

    :deep(.p-fileupload) {
        float: left;
    }

    & > div {
        float: left !important;
    }
}

:deep(.setClassTd .p-selection-column) {
    .p-checkbox {
        //left: 50%;
        //transform: translateX(-50%);
    }

    //width: 100% !important;
    //display: flex;
    //justify-content: center;
    //align-items: center;
    //border-right: none!important;
    //border-top: none!important;
}

:deep(.p-column-filter-menu-button-active) {
    color: #ffffff !important;
}

:deep(.oneList) {
    min-width: 42px !important;
    background: #FFFFFF;
    //display: flex;
    //justify-content: space-between;
    //align-items: center;
    //padding: 10px;
    //border-bottom: 1px solid #ccc;
    border-left-width: 1px !important;
    //border-right-width: 0 !important ;
    width: 42px !important;
    left: 0;
    z-index: 99;
}

:deep(.setClassTd .p-selection-column) {
    background: #FFFFFF;
}

:deep(.p-highlight .p-selection-column) {
    background: linear-gradient(0deg, rgba(15, 139, 253, 0.1), rgba(15, 139, 253, 0.1)), #FFFFFF;
}

:deep(.setClassTd tr:not(.p-highlight)) {
    &:hover .p-selection-column {
        background: linear-gradient(0deg, #F0F1F4, #F0F1F4), #FFFFFF;
    }
}

//.setClassTd tr:not(.p-highlight):hover {
//    background: linear-gradient(0deg, #F0F1F4, #F0F1F4), #FFFFFF;
//}
:deep(.p-datatable-footer) {
    padding: 0 !important;
}
:deep(.setClassTh) {
    z-index: 2!important;
}
:deep(.p-datatable-loading-overlay) {
    z-index: 110 !important;
}
:deep(.p-datatable.p-datatable-gridlines .p-datatable-header) {
    border: none;;
}
:deep(.p-cell-editing){
    .p-inputtext{
        width:100%;
    }
}
</style>
<style>
.headerBtns > div {
    float: left !important;
}
</style>